import * as COMMON from "../constants";
export class OverlayHandler {
  constructor() {}

  handler(
    this: Element,
    handler: OverlayHandler,
    func: (...params: any) => void,
    arg: [Element, (HTMLElement | null)[]],
    e: Event
  ) {
    e.stopPropagation();
    if (this !== e.target || !this.classList.contains(COMMON.CLASS_NAMES.IS_ACTIVE)) return;
    handler.remove(this);
    func(...arg);
  }

  remove(element: Element) {
    element.classList.remove(COMMON.CLASS_NAMES.IS_ACTIVE);
    if (element.hasAttribute("aria-hidden") && element.getAttribute("aria-hidden") !== "false") {
      element.setAttribute("aria-hidden", "true");
    }
    if (element.getAttribute("aria-exapnded") === "true") {
      element.setAttribute("aria-exapnded", "false");
    }
  }
}
